import { useNavigate } from 'react-router-dom';
import type { Article } from '../../mocks/articles';

const accentText: Record<string, string> = {
  primary: 'text-primary-700 bg-primary-100/70',
  accent: 'text-accent-700 bg-accent-100/70',
  secondary: 'text-secondary-700 bg-secondary-100/70',
  foreground: 'text-foreground-700 bg-foreground-100/60',
};

const colToAccent: Record<string, string> = {
  陈年旧瓜: accentText.primary,
  考古重读: accentText.accent,
  历史爆料: accentText.secondary,
  旧事重提: accentText.foreground,
  当年真相: accentText.accent,
};

export default function ArticleCard({ article }: { article: Article }) {
  const navigate = useNavigate();
  const catStyle = colToAccent[article.category] || accentText.primary;
  return (
    <article
      onClick={() => navigate(`/article/${article.id}`)}
      className="group flex cursor-pointer flex-col overflow-hidden rounded-lg border border-background-200 bg-background-50 transition-shadow hover:shadow-[0_10px_30px_-12px_oklch(var(--foreground-950)_/_0.18)]"
    >
      <div className="relative aspect-[3/2] w-full overflow-hidden bg-background-200">
        <img
          src={article.cover}
          alt={article.coverAlt}
          className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
        <span className={`absolute left-3 top-3 rounded-md px-2.5 py-1 text-xs font-medium ${catStyle}`}>
          {article.category}
        </span>
      </div>
      <div className="flex flex-1 flex-col p-4 md:p-5">
        <h3 className="font-display text-base font-bold leading-snug text-foreground-900 transition-colors group-hover:text-primary-700 md:text-lg">
          {article.title}
        </h3>
        <p className="mt-2 line-clamp-2 text-sm leading-6 text-foreground-600">{article.excerpt}</p>
        <div className="mt-auto flex items-center justify-between pt-4 text-xs text-foreground-500">
          <span className="inline-flex items-center gap-1.5">
            <i className="ri-calendar-line"></i>{article.date.slice(0, 10)}
          </span>
          <span className="inline-flex items-center gap-1.5">
            <i className="ri-eye-line"></i>{(article.views / 1000).toFixed(1)}k 阅读
          </span>
          <span className="hidden sm:inline-flex items-center gap-1.5">
            <i className="ri-time-line"></i>{article.readTime}
          </span>
        </div>
      </div>
    </article>
  );
}